import { Reveal, Overline } from "../Reveal";
import { TEAM } from "../../data";

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative bg-[#FAFAFA] py-28 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>The team</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-zinc-900 mt-6 leading-tight">
              Scientists, builders and clinicians.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6 mt-16">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.08}>
              <div
                data-testid={`team-card-${i}`}
                className="group relative aspect-[3/4] rounded-2xl overflow-hidden bg-zinc-200 border border-black/5"
              >
                <img
                  src={m.img}
                  alt={m.name}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-heading text-base lg:text-lg font-medium text-white leading-tight">
                    {m.name}
                  </h3>
                  <p className="font-mono text-[10px] lg:text-[11px] tracking-wider uppercase text-white/75 mt-1.5">
                    {m.role}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
